<script setup lang="ts">
import type { Search } from "~/common/types/types";
import Joi from 'joi'
import type { FormErrorEvent } from '#ui/types'
import EditSearch from "./EditSearch.vue";
import { isEntityId } from "../util";

const search = defineModel({
  required: true,
  type: Object as PropType<Search>   
})

const schema = Joi.object({
  _id: Joi.custom(isEntityId),
  name: Joi.string().required(),
  status: Joi.string().required(),
  threshold: Joi.number().required(),
  clientId: Joi.custom(isEntityId),
  created: Joi.date().required(),
  updated: Joi.date().required(),
  description: Joi.string().allow(''),
  results: Joi.optional()
})

const emit = defineEmits(['submitted'])

async function onSubmit () {
  emit('submitted', search.value);
}

async function onError (event: FormErrorEvent) {
  console.log(event.errors)
}

</script>

<template>
    <UForm :schema="schema" :state="search" class="space-y-4" @submit="onSubmit" @error="onError" >
      
      <EditSearch v-model="search" />

      <UButton type="submit" class="mt-3">
        Create Search
      </UButton>
    </UForm>
</template>